export const restrictedData: string[] = ["Driver", "Guide"]